/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 搜索白页推荐
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class FindRecommendParams {
  constructor(public page: number, public size: number) {}
}

export default async function (
  params: FindRecommendParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.CommodityDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/commodities/recommend`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
